import i18n from '../../../i18n'

import { TASK_FORM_YES_NO_OPTION_VALUE } from './TaskFormYesNoConfirmationModal.constants'

export function getOptions() {
  return [
    {
      id: TASK_FORM_YES_NO_OPTION_VALUE.Yes,
      label: i18n.t('Task.FormYesNoConfirmationModalYesOptionKey'),
    },
    {
      id: TASK_FORM_YES_NO_OPTION_VALUE.No,
      label: i18n.t('Task.FormYesNoConfirmationModalNoOptionKey'),
    },
  ]
}
